import React from 'react';
// import Iconfont from '@gp/components/Iconfont';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import CardSlot from '@gp/components/CardSlot';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import { isValidNumber } from '@gp/utils/common';

import './index.scss';

interface CommonSourceCardPropsType {
  title: string;
  value: string;
  date?: string;
  count?: number | undefined;
  isDate?: boolean;
  slot?: string | JSX.Element | null;
  isNoData?: boolean;
  isLoading?: boolean;
}

const CommonSourceCard: React.FC<CommonSourceCardPropsType> = (props) => {
  const {
    title = '',
    value = '',
    date = '',
    count,
    isDate = true,
    slot = null,
    isNoData = false,
    isLoading = false,
  } = props;

  return (
    <CardSlot
      className="dbg-studio-overall-projects-development-budget-card"
      title={
        <div className="dbg-studio-overall-projects-development-budget-card__title">
          <EllipsisTextBubble
            className="title-text"
            bubbleStyle={isDate ? { width: 'auto', maxWidth: 'calc(100% - 112px)' } : {}}
            text={title}
          />
          {isDate && <div className="value-time">{date || '-'}</div>}
        </div>
      }
    >
      {isLoading ? (
        <Loading loading style={{ height: 80, marginTop: 20 }} />
      ) : (
        <>
          {isNoData || (
            <>
              <div className="source-card-info">
                {/* <article className="value-date">{isDate ? date || '-' : ''}</article>
                <aside className="value-data">{value || '-'}</aside> */}
                <div className="vaule-including">Including {isValidNumber(count) ? count : '-'} projects</div>
                <div
                  className="value-data"
                  style={{
                    // height: isDate ? '' : 62,
                    marginTop: isDate ? '' : 0,
                  }}
                >
                  {value || '-'}
                </div>
              </div>
              {slot && <div className="source-card-footer">{slot}</div>}
            </>
          )}
          {/* 空态 */}
          {isNoData && <NoData height={70} constomStyle={{ fontSize: 14 }} />}
        </>
      )}
    </CardSlot>
  );
};

export default React.memo(CommonSourceCard);
